import MuiBreadcrumbs, { BreadcrumbsProps as MuiProps } from '@material-ui/core/Breadcrumbs';
import React, { FunctionComponent } from 'react';
import { IconButton, Typography, Box } from '@material-ui/core';

export type TLink = {
    name: JSX.Element | React.ReactNode | string;
    url: string;
    componentLink: React.ElementType;
};
export interface BreadcrumbsProps extends MuiProps {
    onBackPress?: () => void;
    links?: TLink[];
}

const IconSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width="24"
        height="24"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
    >
        <path d="M20 11v2H8l5.5 5.5l-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5L8 11h12z" fill="currentColor" />
    </svg>
);

const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({
    children,
    links,
    onBackPress,
    ...rest
}: BreadcrumbsProps) => {
    const BackButton = () => {
        return onBackPress ? (
            <Box mr={1}>
                <IconButton data-testid="icon-back-button" size="small" color="primary" onClick={onBackPress}>
                    <IconSvg />
                </IconButton>
            </Box>
        ) : null;
    };

    // Breadcrumbs with links on props
    const BreadcrumbsWithLinks = () => {
        const renderLink = ({ url, name, componentLink: Link }: TLink) => {
            return (
                <Link key={name} to={url} style={{ textDecoration: 'none' }}>
                    <Typography>{name}</Typography>
                </Link>
            );
        };

        return (
            <Box display="flex" alignItems="center">
                <BackButton />
                <MuiBreadcrumbs separator=">" {...rest}>
                    {links.map((link) => renderLink(link))}
                </MuiBreadcrumbs>
            </Box>
        );
    };

    // Breadcrumbs
    const Breadcrumbs = () => {
        return (
            <Box display="flex" alignItems="center">
                <BackButton />
                <MuiBreadcrumbs separator=">" {...rest}>
                    {children}
                </MuiBreadcrumbs>
            </Box>
        );
    };

    return links ? <BreadcrumbsWithLinks /> : <Breadcrumbs />;
};

export default Breadcrumbs;
